// FNP-861: READ-ONLY. No mutations.ts in this module — the lifecycle machinery owns
// createSyntheticUser / updateSyntheticUser / retireSyntheticUser.
//
// `secretArn` is INTENTIONALLY NOT SELECTED. It exists on the schema (String!) but
// the console has no reason to hold it: the row carries a reference to a credential,
// not a credential. Not selecting it means the value never enters the browser at
// all, so no component can leak it and no future change can accidentally surface it.
// Do not add it to this list.

const SYNTHETIC_USER_FIELDS = `
    id
    personaId
    email
    accountId
    cognitoSub
    bornAt
    plannedLifespanDays
    nextWakeAt
    lifecycleStage
    state
    createdByUsername
    updatedByUsername
    created
    updated
`;

export const listSyntheticUsers = `
   query listSyntheticUsers($filter: SyntheticUsersFilterInput, $limit: Int, $nextToken: String) {
       listSyntheticUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
           items {${SYNTHETIC_USER_FIELDS}}
           nextToken
       }
   }
`;

export const getSyntheticUser = `
   query getSyntheticUser($id: ID!) {
       getSyntheticUser(id: $id) {${SYNTHETIC_USER_FIELDS}}
   }
`;
